import { useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { useElementTypes } from '@editorHooks'
import type { DesignFormRootValues } from '../types'
import { buildHiddenSupportPositionPredicate } from '../utils'

/**
 * Predicate that tells whether a support (identified by its relative position)
 * should be hidden because it is the "second support" of a rip or column.
 * Mirrors the SupportsGridRow filtering so the "Auflager" and "Charakteristische
 * Auflagerkräfte" tables stay in sync with the supports grid.
 */
export const useHiddenSupportPosition = (
  elementId?: string,
): ((relativePosition?: string | number) => boolean) => {
  const elementTypesByGuid = useElementTypes()
  const rootElementType = elementId ? elementTypesByGuid[elementId] : undefined

  const supportConfigs = useWatch<DesignFormRootValues>({
    name: 'elements.0.memberCheckSettingsSelectedElement.support_configs',
  }) as SupportConfig[] | null | undefined

  const supportConfigIndexToElementIndex = useWatch<DesignFormRootValues>({
    name: 'supportConfigIndexToElementIndex',
  }) as DesignFormRootValues['supportConfigIndexToElementIndex']

  return useMemo(
    () =>
      buildHiddenSupportPositionPredicate(
        rootElementType,
        supportConfigs,
        supportConfigIndexToElementIndex,
      ),
    [rootElementType, supportConfigs, supportConfigIndexToElementIndex],
  )
}
